import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { initSlider } from '../js/components/slider';
import { initPageAnimations } from '../js/components/pageAnim';

// Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';

// Görselleri import edelim
import slideImg1 from '../images/blank/slide-img-1.avif';
import slideImg2 from '../images/blank/slide-img-2.avif';
import slideImg3 from '../images/blank/slide-img-3.avif';
import caseStudySlide1 from '../images/blank/case-study-slide-1.png';
import pointDifImg1 from '../images/blank/point-dif-img.avif';
import pointDifImg2 from '../images/blank/point-dif-img-2.jpg';
import pointDifImg3 from '../images/blank/point-dif-img-3.jpg';
import pointDifImg4 from '../images/blank/point-dif-img-4.jpg';
import newsImg1 from '../images/blank/news-1.jpg';
import newsImg2 from '../images/blank/news-2.jpg';
import newsImg3 from '../images/blank/news-3.jpg';
import newsImg4 from '../images/blank/news-4.jpg';
import newsImg5 from '../images/blank/news-5.jpg';
import newsImg6 from '../images/blank/news-6.jpg';
import newsImg7 from '../images/blank/news-7.jpg';
import newsImg8 from '../images/blank/news-8.jpg';
import caseStudySlide2 from '../images/blank/case-study-slide-2.png';
import caseStudySlide3 from '../images/blank/case-study-slide-3.png';
import partnerImg1 from '../images/blank/partner-img1.png';
import partnerImg2 from '../images/blank/partner-img2.png';
import partnerImg3 from '../images/blank/partner-img3.png';
import partnerImg4 from '../images/blank/partner-img4.png';
import partnerImg5 from '../images/blank/partner-img5.png';
import partnerImg6 from '../images/blank/partner-img6.png';
import partnerImg7 from '../images/blank/partner-img7.png';
import partnerImg8 from '../images/blank/partner-img8.png';
import partnerImg9 from '../images/blank/partner-img9.png';
import partnerImg10 from '../images/blank/partner-img10.png';
import partnerImg11 from '../images/blank/partner-img11.png';
import careerImg1 from '../images/blank/career-img1.jpeg';
import careerImg2 from '../images/blank/career-img2.jpeg';

const Home = () => {
  useEffect(() => {
    initSlider();
    const cleanup = initPageAnimations();
    
    return () => {
      cleanup();
    };
  }, []);

  return (
    <div className="home">
      {/* Home Slide */}
      <section className="home-slide w-full bg-black">
        <div className="s-box wd-container py-24 xxl__py-36 mx-auto">
          <h1 className="window-load-slide-text m-0 font-semibold flex items-center flex-wrap justify-center text-5xl lg__text-7xl xxxl__text-8xl">
            <span>We</span>
            <div className="slide-video-hv img bg-cover bg-center mx-1 overflow-hidden" style={{ backgroundImage: `url(${slideImg1})` }}>
              <video src="https://www.w3schools.com/html/mov_bbb.mp4" playsInline muted loop />
            </div>
            <span>put&nbsp;</span>
            <span>the</span>
            <div className="line w-full"></div>
            <span>world</span>
            <div className="slide-video-hv img bg-cover bg-center mx-1 overflow-hidden" style={{ backgroundImage: `url(${slideImg2})` }}>
              <video src="https://www.w3schools.com/html/mov_bbb.mp4" playsInline muted loop />
            </div>
            <span>in&nbsp;</span>
            <span>a</span>
            <div className="slide-video-hv img bg-cover bg-center mx-1 overflow-hidden" style={{ backgroundImage: `url(${slideImg3})` }}>
              <video src="https://www.w3schools.com/html/mov_bbb.mp4" playsInline muted loop />
            </div>
            <span>cloud</span>
          </h1>
          <div className="window-load-slide-desc desc text-white mt-8 lg__mt-12 mb-8 lg__mb-10 text-lg text-center relative z-10">
            We don't just build apps, we build global brands. Let's grow together.
          </div>
          <div className="window-load-slide-video-play video-play flex items-center justify-center relative z-10">
            <Link to="#" className="text-white items-center flex gap-3 pr-5 text-sm font-medium">
              <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M14.9565 29.0435C22.7127 29.0435 29 22.7562 29 15C29 7.2438 22.7127 0.956543 14.9565 0.956543C7.20028 0.956543 0.913025 7.2438 0.913025 15C0.913025 22.7562 7.20028 29.0435 14.9565 29.0435ZM12.7744 9.30705C12.3584 9.06324 11.8357 9.36495 11.8357 9.84648V19.992C11.8357 20.5071 12.4232 20.7997 12.8346 20.4919L20.4453 14.7836C20.8026 14.5154 20.7714 13.9699 20.3851 13.7444L12.7744 9.30705Z" fill="white"/>
              </svg>
              <span>Watch the demo</span>
            </Link>
          </div>
        </div>
      </section>

      {/* Case Study */}
      <section className="home-case-study bg-black relative">
        <div className="bg absolute bottom-0 w-full">
          <svg width="1440" height="749" viewBox="0 0 1440 749" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
            <mask id="mask0_1_121" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="1440" height="749">
              <rect opacity="0.8" width="1440" height="749" fill="black"/>
            </mask>
            <g mask="url(#mask0_1_121)">
              <g filter="url(#filter0_f_1_121)">
                <path d="M1440 749L104 746.5L261.773 688.022C599.009 563.026 955.973 499.689 1315.63 501.035L1440 501.5V749Z" fill="#0075FF"/>
              </g>
            </g>
            <defs>
              <filter id="filter0_f_1_121" x="-196" y="201.014" width="1936" height="847.986" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="150" result="effect1_foregroundBlur_1_121"/>
              </filter>
            </defs>
          </svg>
        </div>
        <div className="left-padding-container mx-auto relative">
          <div className="text-white xxl__pl-[11.81%]">
            <div className="p-top text-white max-w-[1100px]">
              <h2 className="text-white square-text-icon">Case Study</h2>
              <p>We don't just build apps, we build global brands. Let's grow together.</p>
            </div>
            <div className="case-study-slide w-full overflow-hidden">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <img src={caseStudySlide1} alt="" />
                  <div className="s-box">
                    <div className="s-text">Blueprint successfully transformed into a data-driven organization by leveraging cloud technology.</div>
                    <div className="s-link">
                      <Link to="#">
                        <span>Keep reading</span>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.3999 7.6001L0.599902 7.6001" stroke="black" strokeWidth="1.6"/>
                          <path d="M9.1333 14L13.4 7.6L9.1333 1.2" stroke="black" strokeWidth="1.6"/>
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <img src={caseStudySlide2} alt="" />
                  <div className="s-box">
                    <div className="s-text">Blueprint successfully transformed into a data-driven organization by leveraging cloud technology.</div>
                    <div className="s-link">
                      <Link to="#">
                        <span>Keep reading</span>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.3999 7.6001L0.599902 7.6001" stroke="black" strokeWidth="1.6"/>
                          <path d="M9.1333 14L13.4 7.6L9.1333 1.2" stroke="black" strokeWidth="1.6"/>
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <img src={caseStudySlide3} alt="" />
                  <div className="s-box">
                    <div className="s-text">Blueprint successfully transformed into a data-driven organization by leveraging cloud technology.</div>
                    <div className="s-link">
                      <Link to="#">
                        <span>Keep reading</span>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.3999 7.6001L0.599902 7.6001" stroke="black" strokeWidth="1.6"/>
                          <path d="M9.1333 14L13.4 7.6L9.1333 1.2" stroke="black" strokeWidth="1.6"/>
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <img src={caseStudySlide2} alt="" />
                  <div className="s-box">
                    <div className="s-text">Blueprint successfully transformed into a data-driven organization by leveraging cloud technology.</div>
                    <div className="s-link">
                      <Link to="#">
                        <span>Keep reading</span>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.3999 7.6001L0.599902 7.6001" stroke="black" strokeWidth="1.6"/>
                          <path d="M9.1333 14L13.4 7.6L9.1333 1.2" stroke="black" strokeWidth="1.6"/>
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="swiper-pagination"></div> */}
            </div>
            <div className="case-study-slide-bottom flex items-center justify-between mt-8">
              <div className="text">We don't just build apps, we build global brands. Let's grow together.</div>
              <div className="arr-box flex">
                <div className="arr hm-case-study-prev">
                  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="15" cy="15" r="15" fill="#00DDFF"/>
                    <path d="M10.2 15H19.8" stroke="#0F509D" strokeWidth="1.4"/>
                    <path d="M13.3999 10.2002L10.1999 15.0002L13.3999 19.8002" stroke="#0F509D" strokeWidth="1.4"/>
                  </svg>
                </div>
                <div className="arr hm-case-study-next">
                  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="15" cy="15" r="15" transform="matrix(-1 0 0 1 30 0)" fill="#00DDFF"/>
                    <path d="M19.8 15H10.2" stroke="#0F509D" strokeWidth="1.4"/>
                    <path d="M16.6001 10.2002L19.8001 15.0002L16.6001 19.8002" stroke="#0F509D" strokeWidth="1.4"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Points of Difference */}
      <section className="point-difference relative">
        <div className="o-container wd-container">
          <div className="p-top text-white mb-11 max-w-[1100px] mx-auto">
            <h2 className="text-white square-text-icon color-light-green mb-2">Our points of difference</h2>
            <p className="text-lg">We don't just build apps, we build global brands. Let's grow together.</p>
          </div>
          <div className="point-difference-list">
            <div className='swiper-wrapper'>
              <div className="swiper-slide item relative overflow-hidden">
                <div className="img w-full h-full relative">
                  <img src={pointDifImg1} alt="" />
                  <div className="shadow absolute top-0 left-0 w-full h-full bg-black opacity-40"></div>
                </div>
                <div className="box absolute top-0 left-0 w-full h-full flex flex-col p-8">
                  <div className="square mb-5 w-[23px] h-[23px] bg-[#0075FF]"></div>
                  <h3 className="text-white text-2xl font-normal">Discover the Power of Cloud in<br/>Digital Transformation!</h3>
                  <div className="buttons mt-auto">
                    <Link to="#" className="w-56 h-10 px-3 flex items-center text-white text-base font-normal" style={{ backgroundColor: '#0075FF' }}>
                      <span className="flex-1">#Viewpoint</span>
                      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.8 7.3999L-1.24574e-05 7.3999" stroke="#F5F5F5" strokeWidth="1.6"/>
                        <path d="M8.53336 13.7998L12.8 7.39981L8.53336 0.999805" stroke="#F5F5F5" strokeWidth="1.6"/>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            <div className="swiper-slide item relative overflow-hidden">
              <div className="img w-full h-full relative">
                <img src={pointDifImg2} alt=""/>
                <div className="shadow absolute top-0 left-0 w-full h-full bg-black opacity-40"></div>
              </div>
              <div className="box absolute top-0 left-0 w-full h-full flex flex-col p-8">
                <div className="square mb-5"></div>
                <h3 className="text-white text-2xl font-normal">Blueprint's cloud solutions helped<br/>achieve significant cost savings and scalability.</h3>
                <div className="buttons mt-auto">
                  <Link to="#" className="w-56 h-10 px-3 flex items-center text-black text-base font-normal" style={{ backgroundColor: '#3CF9BA' }}>
                    <span className="flex-1">#Reposts</span>
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.8 7.3999L-1.24574e-05 7.3999" stroke="#000000" strokeWidth="1.6"/>
                      <path d="M8.53336 13.7998L12.8 7.39981L8.53336 0.999805" stroke="#000000" strokeWidth="1.6"/>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
            <div className="swiper-slide item relative overflow-hidden">
              <div className="img w-full h-full relative">
                <img src={pointDifImg3} alt="" />
                <div className="shadow absolute top-0 left-0 w-full h-full bg-black opacity-40"></div>
              </div>
              <div className="box absolute top-0 left-0 w-full h-full flex flex-col p-8">
                <div className="square mb-5"></div>
                <h3 className="text-white text-2xl font-normal">Blueprint's cloud solutions helped<br/>achieve significant cost savings and scalability.</h3>
                <div className="buttons mt-auto">
                  <Link to="#" className="w-56 h-10 px-3 flex items-center text-black text-base font-normal" style={{ backgroundColor: '#FFD747' }}>
                    <span className="flex-1">#Reposts</span>
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.8 7.3999L-1.24574e-05 7.3999" stroke="#000000" strokeWidth="1.6"/>
                      <path d="M8.53336 13.7998L12.8 7.39981L8.53336 0.999805" stroke="#000000" strokeWidth="1.6"/>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
            <div className="swiper-slide item relative overflow-hidden">
              <div className="img w-full h-full relative">
                <img src={pointDifImg4} alt="" />
                <div className="shadow absolute top-0 left-0 w-full h-full bg-black opacity-40"></div>
              </div>
              <div className="box absolute top-0 left-0 w-full h-full flex flex-col p-8">
                <div className="square mb-5 w-[23px] h-[23px] bg-[#FFFFFF]"></div>
                <h3 className="text-white text-2xl font-normal">Discover the Power of Cloud in<br/>Digital Transformation!</h3>
                <div className="buttons mt-auto">
                  <Link to="#" className="w-56 h-10 px-3 flex items-center text-white text-base font-normal" style={{ backgroundColor: '#7D63FF' }}>
                    <span className="flex-1">#Infographics</span>
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.8 7.3999L-1.24574e-05 7.3999" stroke="#F5F5F5" strokeWidth="1.6"/>
                      <path d="M8.53336 13.7998L12.8 7.39981L8.53336 0.999805" stroke="#F5F5F5" strokeWidth="1.6"/>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </section>

      {/* News */}
      <section className="bp-news">
        <div className="o-container wd-container">
          <div className="p-top text-white mb-11 mx-auto">
            <h2 className="text-white square-text-icon color-light-green mb-0">Blueprint news</h2>
            <p className="text-lg">An alt text will come here to make the user do a CTA!</p>
          </div>
          <div className="home-news-list">
            <div className="swiper-wrapper">
              <div className="swiper-slide item">
                <div className="w-full h-full overflow-hidden relative">
                  <div className="img w-full h-full absolute">
                    <img src={newsImg1} alt="" className="w-full h-full object-cover" />
                  </div>
                  <div className="box absolute">
                    <div className="square mb-8" style={{ backgroundColor: '#FFFFFF' }}></div>
                    <div className="desc">Experienced a dramatic increase in agility and innovation after partnering with Blueprint.</div>
                    <div className="lnk">
                      <Link to="#">
                        <span>Keep reading</span>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.4 7.6001L0.599963 7.6001" stroke="black" strokeWidth="1.6"/>
                          <path d="M9.13333 14L13.4 7.6L9.13333 1.2" stroke="black" strokeWidth="1.6"/>
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide item reverse">
                <div className="w-full h-full overflow-hidden relative">
                  <div className="img w-full h-full absolute">
                    <img src={newsImg2} alt="" className="w-full h-full object-cover" />
                  </div>
                  <div className="box absolute">
                    <div className="square mb-8" style={{ backgroundColor: '#FFFFFF' }}></div>
                    <div className="lnk">
                      <Link to="#">
                        <span>Keep reading</span>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.4 7.6001L0.599963 7.6001" stroke="black" strokeWidth="1.6"/>
                          <path d="M9.13333 14L13.4 7.6L9.13333 1.2" stroke="black" strokeWidth="1.6"/>
                        </svg>
                      </Link>
                    </div>
                    <div className="desc">Experienced a dramatic increase in agility and innovation after partnering with Blueprint.</div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide item">
                <div className="w-full h-full overflow-hidden relative">
                  <div className="img w-full h-full absolute">
                    <img src={newsImg3} alt="" className="w-full h-full object-cover" />
                  </div>
                  <div className="box absolute">
                    <div className="square mb-8" style={{ backgroundColor: '#FFFFFF' }}></div>
                    <div className="desc">Experienced a dramatic increase in agility and innovation after partnering with Blueprint.</div>
                    <div className="lnk">
                      <Link to="#">
                        <span>Keep reading</span>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.4 7.6001L0.599963 7.6001" stroke="black" strokeWidth="1.6"/>
                          <path d="M9.13333 14L13.4 7.6L9.13333 1.2" stroke="black" strokeWidth="1.6"/>
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide item reverse">
                <div className="w-full h-full overflow-hidden relative">
                  <div className="img w-full h-full absolute">
                    <img src={newsImg4} alt="" className="w-full h-full object-cover" />
                  </div>
                  <div className="box absolute">
                    <div className="square mb-8" style={{ backgroundColor: '#FFFFFF' }}></div>
                    <div className="lnk">
                      <Link to="#">
                        <span>Keep reading</span>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.4 7.6001L0.599963 7.6001" stroke="black" strokeWidth="1.6"/>
                          <path d="M9.13333 14L13.4 7.6L9.13333 1.2" stroke="black" strokeWidth="1.6"/>
                        </svg>
                      </Link>
                    </div>
                    <div className="desc">Experienced a dramatic increase in agility and innovation after partnering with Blueprint.</div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide item">
                <div className="w-full h-full overflow-hidden relative">
                  <div className="img w-full h-full absolute">
                    <img src={newsImg5} alt="" className="w-full h-full object-cover" />
                  </div>
                  <div className="box absolute">
                    <div className="square mb-8" style={{ backgroundColor: '#FFFFFF' }}></div>
                    <div className="desc">Experienced a dramatic increase in agility and innovation after partnering with Blueprint.</div>
                    <div className="lnk">
                      <Link to="#">
                        <span>Keep reading</span>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.4 7.6001L0.599963 7.6001" stroke="black" strokeWidth="1.6"/>
                          <path d="M9.13333 14L13.4 7.6L9.13333 1.2" stroke="black" strokeWidth="1.6"/>
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide item reverse">
                <div className="w-full h-full overflow-hidden relative">
                  <div className="img w-full h-full absolute">
                    <img src={newsImg6} alt="" className="w-full h-full object-cover" />
                  </div>
                  <div className="box absolute">
                    <div className="square mb-8" style={{ backgroundColor: '#FFFFFF' }}></div>
                    <div className="lnk">
                      <Link to="#">
                        <span>Keep reading</span>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.4 7.6001L0.599963 7.6001" stroke="black" strokeWidth="1.6"/>
                          <path d="M9.13333 14L13.4 7.6L9.13333 1.2" stroke="black" strokeWidth="1.6"/>
                        </svg>
                      </Link>
                    </div>
                    <div className="desc">Experienced a dramatic increase in agility and innovation after partnering with Blueprint.</div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide item">
                <div className="w-full h-full overflow-hidden relative">
                  <div className="img w-full h-full absolute">
                    <img src={newsImg7} alt="" className="w-full h-full object-cover" />
                  </div>
                  <div className="box absolute">
                    <div className="square mb-8" style={{ backgroundColor: '#FFFFFF' }}></div>
                    <div className="desc">Experienced a dramatic increase in agility and innovation after partnering with Blueprint.</div>
                    <div className="lnk">
                      <Link to="#">
                        <span>Keep reading</span>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.4 7.6001L0.599963 7.6001" stroke="black" strokeWidth="1.6"/>
                          <path d="M9.13333 14L13.4 7.6L9.13333 1.2" stroke="black" strokeWidth="1.6"/>
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide item reverse">
                <div className="w-full h-full overflow-hidden relative">
                  <div className="img w-full h-full absolute">
                    <img src={newsImg8} alt="" className="w-full h-full object-cover" />
                  </div>
                  <div className="box absolute">
                    <div className="square mb-8" style={{ backgroundColor: '#FFFFFF' }}></div>
                    <div className="lnk">
                      <Link to="#">
                        <span>Keep reading</span>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.4 7.6001L0.599963 7.6001" stroke="black" strokeWidth="1.6"/>
                          <path d="M9.13333 14L13.4 7.6L9.13333 1.2" stroke="black" strokeWidth="1.6"/>
                        </svg>
                      </Link>
                    </div>
                    <div className="desc">Experienced a dramatic increase in agility and innovation after partnering with Blueprint.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="more-btn mt-5 flex justify-between items-center">
            <p className="text-base md__text-lg text-white m-0">To read our other news...</p>
            <div className="lnk flex">
              <Link to="#" className="flex items-center gap-7 h-10 pl-5 pr-4 text-base text-white rounded">
                <span>Load More</span>
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.4 7.6001L0.600024 7.6001" stroke="#F5F5F5" strokeWidth="1.6"/>
                  <path d="M9.1333 14L13.4 7.6L9.1333 1.2" stroke="#F5F5F5" strokeWidth="1.6"/>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Partners */}
      <section className="bp-partners">
        <div className="o-container wd-container">
          <div className="p-top text-white mb-11 mx-auto">
            <h2 className="text-white square-text-icon color-light-green mb-3">The partner ecosystem built for business growth</h2>
            <p className="text-lg">Leave a lasting impact on your career journey with decisive strides.</p>
          </div>
          <div className="partner-list grid grid-cols-2 md__grid-cols-4 gap-10 md__gap-y-16 lg__gap-y-24">
            <div className="item">
              <img src={partnerImg1} alt="" />    
            </div>
            <div className="item">
              <img src={partnerImg2} alt="" />
            </div>
            <div className="item">
              <img src={partnerImg3} alt="" />
            </div>
            <div className="item">
              <img src={partnerImg4} alt="" />
            </div>
            <div className="item">
              <img src={partnerImg5} alt="" />
            </div>
            <div className="item">
              <img src={partnerImg6} alt="" />
            </div>
            <div className="item">
              <img src={partnerImg7} alt="" />
            </div>
            <div className="item">
              <img src={partnerImg8} alt="" />
            </div>
            <div className="item">
              <img src={partnerImg9} alt="" />
            </div>
            <div className="item">
              <img src={partnerImg10} alt="" />
            </div>
            <div className="item">
              <img src={partnerImg11} alt="" />
            </div>
          </div>
        </div>
      </section>

      {/* Career */}
      <section className="bp-career">
        <div className="o-container wd-container">
          <div className="p-top text-white mb-11 wd-container mx-auto">
            <h2 className="text-white square-text-icon color-light-green mb-2">Careers</h2>
            <p className="text-lg">Leave a lasting impact on your career journey with decisive strides.</p>
          </div>
          <div className="career-container bg-black flex flex-row justify-between">
            <div className="text-box text-white">
              <h4 className="text-white mb-3 md__mb-5">Do you want to be one of the pioneers of <span>Blueprint</span> technology?</h4>
              <h5 className="mb-3 md__mb-5">We are waiting for you!</h5>
              <div className="desc text-base md__text-lg text-white mb-5 md__mb-10">Experienced a dramatic increase in agility and innovation after partnering with Blueprint.</div>
              <div className="lnk flex">
                <Link to="#" className="bg-white flex items-center gap-3 h-10 pl-5 pr-0 text-base text-black rounded">
                  <span>Apply now</span>
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20" cy="20" r="20" transform="rotate(-180 20 20)" fill="white"/>
                    <path d="M26.4 20.6001L13.6 20.6001" stroke="black" strokeWidth="1.6"/>
                    <path d="M22.1333 27L26.4 20.6L22.1333 14.2" stroke="black" strokeWidth="1.6"/>
                  </svg>
                </Link>
              </div>
            </div>
            <div className="img-box">
              <div className="img">
                <img src={careerImg1} alt="" />
              </div>
              <div className="img">
                <img src={careerImg2} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 